import { site } from '../data/site'

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      {/* bg decoration */}
      <div
        aria-hidden
        className="absolute inset-0 -z-10 bg-gradient-to-b from-muted to-white"
      />
      <div
        aria-hidden
        className="absolute -top-24 -right-24 w-[480px] h-[480px] rounded-full bg-brand/10 blur-3xl -z-10"
      />

      <div className="w-full px-6 sm:px-10 lg:px-16 pt-16 pb-20 lg:pt-24 lg:pb-28 grid lg:grid-cols-2 gap-12 items-center">
        {/* Left: copy + CTA */}
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-brand/10 text-brand-dark px-3 py-1 text-xs font-semibold tracking-wide">
            <span className="w-1.5 h-1.5 rounded-full bg-brand animate-pulse" />
            {site.name} · {site.fullName}
          </span>

          <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.1] text-navy tracking-tight">
            뉴스로 추적하는
            <br />
            식물병 확산 지도
          </h1>

          <p className="mt-6 text-base sm:text-lg text-navy/70 leading-relaxed">
            전국의 뉴스 기사를 실시간 수집·분석하여{' '}
            <b className="text-navy">과수화상병 · 도열병 · 소나무재선충병</b>의
            발생 지역과 추세를 지도·차트로 시각화합니다. 농가·연구자·방역
            담당자가 가장 빠르게 위험 신호를 포착할 수 있도록 설계된 공공 목적
            대시보드입니다.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href={site.dashboardUrl}
              className="inline-flex items-center gap-2 rounded-full bg-brand text-white font-semibold px-6 py-3 hover:bg-brand-dark transition shadow-card"
            >
              대시보드 <span aria-hidden>→</span>
            </a>
            <a
              href={site.github}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 rounded-full border border-navy/15 text-navy font-semibold px-6 py-3 hover:border-navy/40 hover:bg-white transition"
            >
              GitHub에서 보기 <span aria-hidden>↗</span>
            </a>
          </div>

          <div className="mt-8 flex items-center gap-6 text-xs text-navy/50">
            <span>© 2026 {site.lab}</span>
          </div>
        </div>

        {/* Right: disease chips + stat card */}
        <div className="relative">
          <div className="rounded-3xl border border-black/5 bg-white p-6 sm:p-8 shadow-card">
            <div className="text-xs font-semibold tracking-wider text-navy/50">
              추적 대상 병해
            </div>
            <ul className="mt-4 space-y-3">
              {site.diseases.map((d) => (
                <li
                  key={d.ko}
                  className="flex items-center justify-between rounded-xl bg-muted/60 px-4 py-3"
                >
                  <div className="flex items-center gap-3">
                    <span
                      className="w-2.5 h-2.5 rounded-full"
                      style={{ background: d.tone }}
                    />
                    <div>
                      <div className="font-semibold text-navy">{d.ko}</div>
                      <div className="text-xs text-navy/60">주요 피해 기주: {d.host}</div>
                    </div>
                  </div>
                  <span className="text-xs text-navy/40">tracked</span>
                </li>
              ))}
            </ul>

            <div className="mt-6 grid grid-cols-3 gap-3 text-center">
              <Stat label="병해" value="3" />
              <Stat label="데이터 소스" value="News" />
              <Stat label="업데이트" value="Daily" />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

function Stat({ label, value }: { label: string; value: string }) {
  return (
    <div className="rounded-xl border border-black/5 py-3">
      <div className="text-lg font-extrabold text-navy">{value}</div>
      <div className="text-[10px] text-navy/60 tracking-wider mt-0.5">
        {label}
      </div>
    </div>
  )
}
